module.exports = __webpack_public_path__ + "static/media/MenuCoffee.b21c6eb7.jpg";